import React, { useState } from "react";
import { useSnackbar } from "notistack";
import Loading from "../../../components/loading";
import {
    Button,
    DialogActions,
    DialogContent,
    Divider,
    Grid,
} from "@material-ui/core";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { FTextField, FFilePicker, FSwitch } from "../../../components/form-elements";
import DialogTitle from "../../../components/dialog-title";
import blogsService from "../../../services/blogs.service";
import TextEditor from "../../../components/TextEditor";
import { normalizeEditorHtml, uploadBase64Images } from "../../../helpers/html-images";

const emptyValues = {
    title: "",
    slug: "",
    summary: "",
    keywords: "",
    status: true,
    image: undefined,
};

export default function FormModalContent({ close, data }) {
    const [waiting, setWaiting] = useState(false);
    const [description, setDescription] = useState(data?.description || "")

    const { enqueueSnackbar } = useSnackbar();
    const { id, ...initialValues } = {...data, status: data?.status === "publish"} || {};

    const handleError = (error) => {
        let message;
        let variant;
        switch (error) {
            case "NameTaken":
                message = "این نام استفاده شده است.";
                variant = "error";
                break;
            case "BlogNotfound":
                message = "بلاگ مورد نظر یافت نشد.";
                variant = "error";
                break;
            case "DuplicateName":
                message = "این نام تکراری است.";
                variant = "error";
                break;
            default:
                message = "اتفاقی افتاده، لطفا بعدا تلاش کنید.";
                variant = "error";
        }
        enqueueSnackbar(message, { variant });
    };

    const handleSubmit = async (model) => {
        model.status = model.status ? "publish" : "draft";
        model.description = normalizeEditorHtml(
            await uploadBase64Images(description),
        );

        setWaiting(true);
        let op;
        if (id) {
            op = await blogsService.editBlog(id, model);
        } else {
            op = await blogsService.createBlog(model);
        }
        const { error } = op;
        setWaiting(false);
        if (error) {
            handleError(error);
            return;
        }
        close(true);
    };
    return (
        <Loading isLoading={waiting} fullPage={true} overlay>
            <DialogTitle onClose={() => close()}>
                {id ? "ویرایش بلاگ" : "ایجاد بلاگ"}
            </DialogTitle>
            <Divider />
            <Formik
                initialValues={id ? initialValues : emptyValues}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting, values }) => (
                    <Form autoComplete="off">
                        <DialogContent style={{overflowX: "hidden"}}>
                            <Grid container spacing={2}>
                                <Grid items xs={4} className="p-1">
                                    <FTextField name="title" label="عنوان" autoFocus />
                                    <FTextField name="slug" label="اسلاگ" />
                                    <FTextField name="keywords" label="کلمات کلیدی" />
                                    <FTextField name="summary" label="خلاصه" type="textarea" multiline rows={4} />
                                    <FFilePicker
                                        imageOptions={{
                                            maxRatio: undefined,
                                            minRatio: undefined,
                                        }}
                                        name="image"
                                        label="عکس"
                                        isImage
                                    />
                                    <FSwitch label="فعال" name="status"/>
                                </Grid>
                                <Grid items xs={8} className="p-1">
                                    <TextEditor 
                                        value={description}
                                        onChange={setDescription}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={close} color="primary" disabled={isSubmitting}>
                                لغو
                            </Button>
                            <Button
                                type="submit"
                                disabled={isSubmitting}
                                variant="contained"
                                color="primary"
                            >
                                {id ? "ذخیره" : "ایجاد"}
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Loading>
    );
}
